

import blogCategories from '@/apollo/queries/blog/blogCategories'
import blogAuthors from '@/apollo/queries/blog/blogAuthors'

export default {
  name: 'BlogFilterSection',
  props: {
    filterMenuActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeItem: "",
      blogCategories: [],
      blogAuthors: [],
      showDesktopMenu: true
    }
  },
  computed: {
    activeType() {
      return this.$store.state.blog.filters.activeType
    },
    blogCategoriesComputed() {
      const uniqueIds = [];

      if(this.blogCategories) {
        const unique = this.blogCategories.filter(element => {
          const isDuplicate = uniqueIds.includes(element?.DisplayName);
          if (!isDuplicate) {
            uniqueIds.push(element?.DisplayName);
            return true;
          }
          return false;
        });
        return unique
      }
      return []
    },
    storeShowDesktopMenu() {
      return this.$store.getters['blog/showDesktopMenu'] 
    }

  },
  updated() {
    this.$nextTick(() => {
      let cat = ''
      if (this.isBlogCategoryPage() && this.$route.params.slug) {
        cat = this.blogCategoriesComputed?.find((item)=>{
          return item.SlugCode === this.$route.params.slug
        })
        if(cat) {
          this.saveToStore(cat.DisplayName)
        } else {
          this.$router.push({
              path: `/${this.$i18n.locale}/blog`,
          })
        }
    }
    })
  },
  watch: {
    storeShowDesktopMenu(newValue, oldValue) {
      this.showDesktopMenu = newValue 
    }
  },
  methods: {
    saveToStore(value) {
      this.$store.commit('blog/setTagCodes', value)
    },
    showMobileMenu() {
      this.$store.commit('blog/setMobileMenuState', true);
    },
    setDesktopMenu(boolean) {
      this.$store.commit('blog/setDesktopMenuState', boolean);
    },
    isBlogCategoryPage() {
      if(this.$route?.name?.includes("blog-category-slug")) {
        return true
      }
      return false
    },
  },
  apollo: {
      blogCategories: {
          prefetch: true,
          query: blogCategories,
          variables() {
              return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
          },
          update(data) {
              return this.$normalizeStrapi(data.blogCategories.data);
          },
          result({ data }) {
              // console.debug("***apollo blogCategories data ***");
              // console.debug(JSON.stringify(data));
          }
      },
      blogAuthors: {
          prefetch: true,
          query: blogAuthors,
          variables() {
              return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
          },
          update(data) {
              return this.$normalizeStrapi(data.blogAuthors.data);
          },
          result({ data }) {
              // console.debug("***apollo blogAuthors data ***");
              // console.debug(JSON.stringify(data));
          },
      },
    },
  }
